// @ts-strict-ignore
import {AfterContentInit, Component, ContentChildren, Input, OnInit, QueryList, ViewChild, output} from "@angular/core";
import {FontAwesomeCode} from "@models";
import {Translations} from "@translations";
import {MatColumnDef, MatTable} from "@angular/material/table";
import {TrackByMethods} from "@services";
import {TableVirtualScrollDataSource} from "ng-table-virtual-scroll";
import {FormControl} from "@angular/forms";
import {debounceTime, distinctUntilChanged, filter} from "rxjs/operators";

export interface GroupBy {
	initial: string;
	isGroupBy: boolean;
	expanded: boolean;
}

@Component({
	selector: "sim-base-administration-checked-action-table",
	templateUrl: "./base-administration-checked-action-table.component.html",
	styleUrls: ["./base-administration-checked-action-table.component.scss"],
	standalone: false,
})
export class BaseAdministrationCheckedActionTableComponent implements OnInit, AfterContentInit {
	// Inputs
	@Input() filterDebounceTime: number = 350;
	@Input() hasAdditionalActions: boolean = false;
	@Input() headerIcon: FontAwesomeCode;
	@Input() translatedHeader: string;
	@Input() enableExpandElement: boolean = false;
	@Input() titleIcon: string;
	@Input() title: string;
	@Input() displayedColumns: string[];
	@Input() dataSource: TableVirtualScrollDataSource<any>;
	@Input() showFilter = false;
	@Input() isGrouped: boolean = false;

	// Properties
	isLoadingResults: boolean = false;
	TrackByMethods = TrackByMethods;
	T = Translations;
	filterFieldShowing: boolean;
	filterInputFormControl = new FormControl("");
	collapsedGroups: string[] = [];

	@ViewChild(MatTable, {static: true}) table: MatTable<any>;
	@ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;
	public filterChanged = output<string>();

	ngOnInit(): void {
		this.filterInputFormControl.valueChanges
			.pipe(
				filter((term) => term != null),
				debounceTime(this.filterDebounceTime),
				distinctUntilChanged(),
			)
			.subscribe((value) => {
				this.filterChanged.emit(value);
			});
	}

	ngAfterContentInit(): void {
		this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef));
	}

	isGroup(index: number, item: any): boolean {
		return item?.isGroupBy;
	}

	isNotGroup(index: number, item: any): boolean {
		if (item?.isGroupBy) {
			return false;
		} else if (item.type === "scenariorecording") {
			return true;
		} else {
			return true;
		}
	}

	public isCollapsed(element: any): boolean {
		return element?.type && this.collapsedGroups.includes(element.type);
	}

	openFilterField(filterInput: HTMLInputElement): void {
		this.filterFieldShowing = !this.filterFieldShowing;
		if (this.filterFieldShowing) {
			filterInput?.focus();
		} else {
			if (filterInput) {
				filterInput.value = "";
			}
			this.filterInputFormControl.setValue("", {emitEvent: true});
		}
	}
}
